import { IoMdClose } from 'react-icons/io';
import accountStyles from 'pages/account/account-option/account-option.style';
import globalStyle from 'constants/global.style';
import styles from './add-bank.style';
import { SubmitHandler, useForm } from 'react-hook-form';
import { BankCardAddPayload } from 'models/bankModel';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import userApi from 'apis/userApi';
import LoadingIcon from 'components/loading/LoadingIcon';
import toast from 'react-hot-toast';
const bankList = [
    { value: 'Ngân Hàng Á Châu (ACB)', label: 'Ngân Hàng Á Châu (ACB)' },
    { value: 'Agribank', label: 'Agribank' },
    { value: 'BIDV', label: 'BIDV' },
    { value: 'Đông Á', label: 'Đông Á' },
    { value: 'EximBank', label: 'EximBank' },
    { value: 'Sacombank', label: 'Sacombank' },
    { value: 'Techcombank', label: 'Techcombank' },
    { value: 'Vietinbank', label: 'Vietinbank' },
    { value: 'Vietcombank', label: 'Vietcombank' },
    { value: 'VIB', label: 'VIB' },
    { value: 'VPBank', label: 'VPBank' },
    { value: 'MaritimeBank', label: 'MaritimeBank' },
    { value: 'SHB', label: 'SHB' },
    { value: 'MBBank', label: 'MBBank' },
    { value: 'otherBank', label: 'Ngân hàng khác' },
];

const locateBank = {
    nprovince: 'Việt Nam',
    ncity: 'Việt Nam',
};

interface Props {
    onSubmit: (bankPayload: BankCardAddPayload) => void;
    onClose: () => void;
    hasExistingBank?: boolean; // true nếu user đã có bank trước đó
}
function AddBankPerson(props: Props) {
    const { onSubmit, onClose, hasExistingBank = false } = props;
    const [step, setStep] = useState<1 | 2>(1);
    const [bankName, setBankName] = useState(bankList[0].value);
    const [loading, setLoading] = useState(false);
    const [bankConfirmData, setBankConfirmData] = useState<BankCardAddPayload>({} as BankCardAddPayload);
    const [hasCheckpwd, setHasCheckpwd] = useState(hasExistingBank);

    useEffect(() => {
        // Check if user already has payment password
        const checkPaymentPwd = async () => {
            try {
                const { data } = await userApi.getBankPersonList({});
                // Nếu có checkpwd trong response thì user đã có mật khẩu thanh toán
                if (data.checkpwd) {
                    setHasCheckpwd(true);
                }
            } catch (error) {
                console.log(error);
            }
        };
        checkPaymentPwd();
    }, []);
    const {
        register,
        handleSubmit,
        setError,
        clearErrors,
        formState: { errors },
    } = useForm<BankCardAddPayload>();

    const submitAddBankCheck: SubmitHandler<BankCardAddPayload> = async (values) => {
        const { nbankcard, bankcard2, nname, checkpwd, checkpwd2 } = values;

        if (nbankcard !== bankcard2) {
            setError('bankcard2', { message: 'Nhập lại số tài khoản không đúng' });
            return;
        }

        // Lần đầu thêm bank: cần xác nhận mật khẩu mới
        if (!hasCheckpwd && checkpwd !== checkpwd2) {
            setError('checkpwd2', { message: 'Nhập lại mật khẩu thanh toán không đúng' });
            return;
        }

        setLoading(true);
        const payload = {
            ...values,
            nname: nname.trim().toLocaleLowerCase(),
            ...locateBank,
            nbankname: bankName,
        };
        try {
            const { data } = await userApi.addBankcardCheck(payload);
            if(!data.msg) {
                setStep(2);
                setBankConfirmData(payload);
            } else {
                toast.error(data.msg);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const changeAlias = (alias: string, removeNumber: boolean, typeInput: any) => {
        let str = alias;
        str = str.toUpperCase();
        if (removeNumber) {
            str = str.replace(/[0-9]/g, '');
        } else {
            str = str.replace(/ /g, '');
        }
        str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ắ|Ằ|Ặ|Ẳ|Ẵ/g, 'A');
        str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, 'E');
        str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, 'I');
        str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, 'O');
        str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, 'U');
        str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, 'Y');
        str = str.replace(/Đ/g, 'D');
        str = str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, '');
        str = str.replace(/ + /g, '');
        if (alias !== '') {
            clearErrors(typeInput);
        }
        return str;
    };

    const handleSubmitAddBank = async () => {
        onSubmit(bankConfirmData);
    };

    return (
        <>
            <div className={styles.wrap}>
                <div className={styles.heading}>
                    <h6>Thêm Ngân Hàng</h6>
                    <button type="button" onClick={onClose}>
                        <IoMdClose size={36} color="#2d276d" />
                    </button>
                </div>
                {/* <div className={styles.breadcrumb}>
                    <div className={classNames(`${styles.breadItem} ${styles.breadItem1}`, { active: step === 1 })}>
                        <p>Điền Thông Tin</p>
                    </div>
                    <div className={classNames(`${styles.breadItem} ${styles.breadItem2}`, { active: step === 2 })}>
                        <p>Xác Nhận</p>
                    </div>
                </div> */}
                {step === 1 && (
                    <form className="" onSubmit={handleSubmit(submitAddBankCheck)}>
                        <div className={`${accountStyles.groupInput} form-group-common`}>
                            <label htmlFor="bankList"></label>
                            <select id="bankList" className="input-common" onChange={(e) => setBankName(e.target.value)}>
                                {bankList.map((bank) => (
                                    <option value={bank.value} key={bank.value}>
                                        {bank.label}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className={accountStyles.groupInput}>
                            <label htmlFor="">Chi Nhánh</label>
                            <div className={accountStyles.wrapInput}>
                                <input
                                    {...register('nbranchname', {
                                        required: true,
                                        maxLength: {
                                            value: 30,
                                            message: 'Tối thiểu 30 ký tự',
                                        },
                                    })}
                                    className={`input-common`}
                                    type="text"
                                    placeholder="Từ 2 đến 30 ký tự"
                                />
                            </div>
                            {/* base error  */}
                            <div className={globalStyle.errorInput}>{errors['nbranchname'] && <small>{errors['nbranchname'].message || 'Vui lòng nhập trường này!'}</small>}</div>
                        </div>

                        <div className={accountStyles.groupInput}>
                            <label htmlFor="">Tên Chủ Tài Khoản</label>
                            <div className={accountStyles.wrapInput}>
                                <input
                                    {...register('nname', {
                                        required: true,
                                    })}
                                    className={`input-common`}
                                    type="text"
                                    placeholder="Từ 2 đến 30 ký tự"
                                    onChange={(e: any) => (e.target.value = changeAlias(e.target.value, true, 'nname'))}
                                />
                            </div>
                            {/* base error  */}
                            <div className={globalStyle.errorInput}>{errors['nname'] && <small>{errors['nname'].message || 'Vui lòng nhập trường này!'}</small>}</div>
                        </div>

                        <div className={accountStyles.groupInput}>
                            <label htmlFor="">Số Tài Khoản</label>
                            <div className={accountStyles.wrapInput}>
                                <input
                                    {...register('nbankcard', {
                                        required: true,
                                    })}
                                    className={`input-common`}
                                    type="text"
                                    placeholder="Từ 1 đến 15 ký tự"
                                    onChange={(e: any) => (e.target.value = changeAlias(e.target.value, false, 'nbankcard'))}
                                />
                            </div>
                            {/* base error  */}
                            <div className={globalStyle.errorInput}>{errors['nbankcard'] && <small>{errors['nbankcard'].message || 'Vui lòng nhập trường này!'}</small>}</div>
                        </div>

                        <div className={accountStyles.groupInput}>
                            <label htmlFor="">Nhập Lại Số Tài Khoản</label>
                            <div className={accountStyles.wrapInput}>
                                <input
                                    {...register('bankcard2', {
                                        required: true,
                                    })}
                                    className={`input-common`}
                                    type="text"
                                    placeholder="Xác minh lại tài khoản ngân hàng"
                                    onChange={(e: any) => (e.target.value = changeAlias(e.target.value, false, 'bankcard2'))}
                                />
                            </div>
                            {/* base error  */}
                            <div className={globalStyle.errorInput}>{errors['bankcard2'] && <small>{errors['bankcard2'].message || 'Vui lòng nhập trường này!'}</small>}</div>
                        </div>

                        <div className={accountStyles.groupInput}>
                            <label htmlFor="">
                                {hasCheckpwd ? 'Mật Khẩu Thanh Toán' : 'Tạo Mật Khẩu Thanh Toán'}
                            </label>
                            <div className={accountStyles.wrapInput}>
                                <input
                                    {...register('checkpwd', {
                                        required: true,
                                    })}
                                    className={`input-common`}
                                    type="password"
                                    placeholder={hasCheckpwd ? 'Nhập mật khẩu thanh toán đã tạo' : 'Tạo mật khẩu thanh toán mới'}
                                />
                            </div>
                            {/* base error  */}
                            <div className={globalStyle.errorInput}>{errors['checkpwd'] && <small>{errors['checkpwd'].message || 'Vui lòng nhập trường này!'}</small>}</div>
                        </div>

                        {/* Chỉ hiển thị xác nhận mật khẩu khi chưa có checkpwd */}
                        {!hasCheckpwd && (
                            <div className={accountStyles.groupInput}>
                                <label htmlFor="">Nhập Lại Mật Khẩu Thanh Toán</label>
                                <div className={accountStyles.wrapInput}>
                                    <input
                                        {...register('checkpwd2', {
                                            required: !hasCheckpwd,
                                        })}
                                        className={`input-common`}
                                        type="password"
                                        placeholder="Xác nhận mật khẩu thanh toán"
                                    />
                                </div>
                                {/* base error  */}
                                <div className={globalStyle.errorInput}>{errors['checkpwd2'] && <small>{errors['checkpwd2'].message || 'Vui lòng nhập trường này!'}</small>}</div>
                            </div>
                        )}

                        <button type="submit" className={`${accountStyles.btnSubmit} btn-primary`} style={{ marginTop: '12px' }}>
                            Bước Tiếp Theo
                        </button>
                    </form>
                )}
                {step === 2 && (
                    <div className="">
                        <p className={styles.noteConfirm}>Vui lòng xác nhận thông tin ngân hàng của bạn một lần nữa.</p>
                        <div className={styles.infoBankList}>
                            <div className={styles.infoBankItem}>
                                <p>Ngân Hàng</p>
                                <p>{bankConfirmData.nbankname}</p>
                            </div>
                            <div className={styles.infoBankItem}>
                                <p>Chi Nhánh</p>
                                <p>{bankConfirmData.nbranchname}</p>
                            </div>
                            <div className={styles.infoBankItem}>
                                <p>Tên Tài Khoản</p>
                                <p>{bankConfirmData.nname}</p>
                            </div>
                            <div className={styles.infoBankItem}>
                                <p>Số Tài Khoản</p>
                                <p>{bankConfirmData.nbankcard}</p>
                            </div>
                        </div>
                        <div className="action-group-modal">
                            <button type="button" className="btn-cancel" onClick={() => setStep(1)}>
                                Quay Lại
                            </button>
                            <button type="button" className="btn-primary" onClick={handleSubmitAddBank}>
                                Xác nhận
                            </button>
                        </div>
                    </div>
                )}
            </div>
            {loading && <LoadingIcon />}
        </>
    );
}

export default AddBankPerson;
